import { sanitizeBoatFilename } from './filename.ts';
import type { BoatDocument } from './types.ts';

export const MAX_BOAT_NAME_LENGTH = 80;
export const UNTITLED_BOAT_NAME = 'Untitled';

/** Display title stored on the document. The file stem is separate. */
export function sanitizeBoatName(raw: string): string {
  return raw
    .replace(/[\u0000-\u001f\u007f]/g, '')
    .replace(/\s+/g, ' ')
    .trim()
    .slice(0, MAX_BOAT_NAME_LENGTH);
}

export function setBoatName(boat: BoatDocument, raw: string): void {
  boat.name = sanitizeBoatName(raw);
}

export function boatDisplayName(name: string, fallback = UNTITLED_BOAT_NAME): string {
  return name.trim() || fallback;
}

/** Catalog fallback when `name` is empty: `sea-skiff` → `Sea Skiff`. */
export function labelFromBoatFilename(fileName: string): string {
  const stem = fileName.replace(/\.json$/i, '');

  if (!stem || stem === UNTITLED_BOAT_NAME) {
    return '';
  }

  return stem.replace(/[-_]+/g, ' ').replace(/\b\w/g, (letter) => letter.toUpperCase());
}

/** Turns a title into a catalog basename, or null if nothing safe remains. */
export function suggestBoatFilename(raw: string): string | null {
  const slug = sanitizeBoatName(raw)
    .toLowerCase()
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 128);

  return slug ? sanitizeBoatFilename(slug) : null;
}
